import type { Technique } from '../types';
import { FORCE_FIELD_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type ForceFieldState } from './render';

export const forceField: Technique<ForceFieldState> = {
  id: 'force-field',
  name: 'Kraftfeld / Orbit',
  category: 'field',
  description: 'Der Text als Ladung; Partikel umkreisen ihn und zeichnen ihre Bahnen.',
  params: FORCE_FIELD_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
